/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Listbox } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'

interface TablePageSelectorItemProps {
    item: number
}

const TablePageSelectorItem: React.FC<TablePageSelectorItemProps> = ({
    item,
}) => {
    return (
        <Listbox.Option
            className={({ active }) =>
                clsx(
                    'TablePageSelectorItem relative cursor-pointer select-none text-base',
                    active ? 'bg-blue-50 text-blue-400' : 'text-gray-900'
                )
            }
            value={item}
        >
            {({ selected }) => (
                <>
                    <span
                        className={`block py-1.5 pl-6 pr-2 truncate ${
                            selected ? 'font-bold' : ' font-normal'
                        }`}
                    >
                        {item}
                    </span>
                    {selected ? (
                        <span
                            className={clsx(
                                'absolute inset-y-0 left-0 flex items-center pl-0.5 text-blue-400'
                            )}
                        >
                            <CheckIcon
                                aria-hidden="true"
                                className={clsx('h-4 w-5')}
                            />
                        </span>
                    ) : null}
                </>
            )}
        </Listbox.Option>
    )
}

export default TablePageSelectorItem
